import React from 'react';

import Buyers from './buyers';
import Owners from './owners';
import Sellers from './sellers';
import Tenants from './tenants';

import './styles.scss';

export default function DealContacts() {
  return <>
    <Buyers/>
    <Sellers/>
    <Owners/>
    <Tenants/>
  </>;
}
